import {
  PROFILE_DETAILS_POPOVER_HEIGHT,
  PROFILE_DETAILS_POPOVER_WIDTH,
} from '@aibees/elephant/constants';
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc = (isLoading: boolean) => ({
  gap: (p) => p.spacing(1),
  width: (p) => p.spacing(PROFILE_DETAILS_POPOVER_WIDTH),
  height: (p) =>
    isLoading ? p.spacing(PROFILE_DETAILS_POPOVER_HEIGHT) : undefined,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: (p) => (isLoading ? p.palette.grey[200] : undefined),
});

export const profileDetailsContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
};

export const configContent: SxStyle = {
  padding: (p) => p.spacing(0, 1, 1, 1),
};
